import React, { useState, useContext, useRef, useEffect } from "react";
import { Form, Button, Container, Card, InputGroup, ToastContainer, Toast } from "react-bootstrap";
import { AuthContext } from "../../contexts/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faEye, faEyeSlash, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FormLoginInterface } from "../../interfaces";
import { MakeMessageError } from "../../components/Components";

const initial: FormLoginInterface = {
    email: '',
    password: '',
}

const Login: React.FC = () => {
    const authContext = useContext(AuthContext);
    const [usuarioForm, setUsuarioForm] = useState<FormLoginInterface>(initial);
    const btnLogin = useRef<HTMLButtonElement>(null);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [theme, setTheme] = useState<"light" | "dark">("light");

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setUsuarioForm({ ...usuarioForm, [name]: value });
        authContext?.clearError(name);
    }

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        if (authContext) {
            btnLogin.current?.setAttribute('disabled', 'disabled');

            await authContext.login(usuarioForm.email, usuarioForm.password);
            btnLogin.current?.removeAttribute('disabled');

        }
    }
    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") as "light" | "dark" | null;
        if (savedTheme) setTheme(savedTheme);
    }, []);

    useEffect(() => {
        document.documentElement.setAttribute("data-bs-theme", theme);
        document.body.setAttribute("data-bs-theme", theme);
        localStorage.setItem("theme", theme);
    }, [theme]);


    const toggleTheme = () => {
        setTheme((prev) => (prev === "light" ? "dark" : "light"));
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <Container style={{ maxWidth: '400px', }}>
                <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                    <Toast bg="danger"
                        onClose={() => authContext?.changeShowError(false)}
                        show={authContext?.showError} delay={4000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Error!</strong>
                        </Toast.Header>
                        <Toast.Body className="text-light fw-bold">{authContext?.showMessageError}</Toast.Body>
                    </Toast>
                </ToastContainer>

                <Form onSubmit={handleLogin}>
                    <Card className="card-primary card-outline">
                        <Card.Header className="py-2 text-center fw-bold card-outline-primary ">

                            <div className="d-flex ">
                                <div className="me-auto ms-auto p-2 text-center">Informe suas credenciais</div>

                                <div className=" p-2">
                                    <div style={{ cursor: 'pointer' }}
                                        title="Trocar tema"
                                        className="rounded-circle"
                                        onClick={toggleTheme}
                                    >
                                        {theme === "light" ? "🌙" : "☀️"}
                                    </div>
                                </div>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Form.Group className="mb-2 position-relative" controlId="email">
                                <div>

                                    <Form.Control type="text" name="email"

                                        placeholder="Informe o e-mail"
                                        value={usuarioForm.email}
                                        onChange={handleChange}
                                        className={`login-input pe-5 ${authContext?.errors?.email?.length !== undefined &&
                                            authContext?.errors?.email?.length > 0 ? "is-invalid" : ""}`
                                        }
                                        autoFocus

                                    />
                                    <FontAwesomeIcon icon={faAt} className={`email-toggle-icon `} />
                                </div>


                            </Form.Group>
                                <MakeMessageError errors={authContext?.errors} field="email" />

                            <Form.Group className="mb-2 position-relative" controlId="password">
                                <div>
                                    <Form.Control

                                        type={showPassword ? "text" : "password"}
                                        placeholder="Informe a senha"
                                        value={usuarioForm.password}
                                        name="password"
                                        onChange={handleChange}
                                        className={`login-input pe-5 ${authContext?.errors?.password?.length ? "is-invalid" : ""}`}
                                    />

                                    <FontAwesomeIcon
                                        icon={showPassword ? faEyeSlash : faEye}
                                        className={`password-toggle-icon `}
                                        onClick={() => setShowPassword(!showPassword)}
                                    />
                                </div>
                            </Form.Group>
                                <MakeMessageError errors={authContext?.errors} field="password" />


                            <div className="d-flex justify-content-between">
                                <Link to="/forgot-password" className="text-decoration-none">Esqueci minha senha</Link>
                            </div>
                        </Card.Body>
                        <Card.Footer className="d-grid gap-2">
                            <Button variant="primary" type="submit" ref={btnLogin}>
                                <FontAwesomeIcon icon={faSignInAlt} title="Entrar" /> Entrar
                            </Button>
                        </Card.Footer>
                    </Card>
                </Form>

            </Container>
        </div >
    );
}

export default Login;